import React from 'react';

const Communication = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Communications with Buyer and/or Seller
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Wherever this Agreement contains a provision that requires or allows
          communication/delivery to a Buyer, those provisions may be satisfied
          only by communication/delivery being made directly to the Buyer,
          unless otherwise agreed to by the parties. Wherever this Agreement
          contains a provision that requires or allows communication/delivery to
          a Seller, that provision shall be satisfied by communication/delivery
          to the Broker for Seller, if any. If there is no Broker for Seller,
          those provisions may be satisfied only by communication/delivery being
          made directly to the Seller, unless otherwise agreed to by the
          parties.
        </li>
        <li>
          Headings: The section and paragraph headings in this Agreement are for
          convenience only and are not intended to indicate all of the matter in
          the sections which follow them. They shall have no effect whatsoever
          in determining the rights, obligations or intent of the parties.
        </li>
      </ol>
    </div>
  );
};

export default Communication;
